import './Copyright.scss'

import React, {Fragment} from 'react'
import {LinkType, WysiwygType} from '../../types'
import {Link} from '../../util/link'
import {style} from '../../util/style'
import {Theme} from '../Theme'

const styles = style('copyright', ['links'])

export type CopyrightType = {
	text?: WysiwygType
	links?: Array<LinkType>
}

export const Copyright: React.FC<CopyrightType> = ({text, links}) => {
	if (!text && (!links || links.length === 0)) return null

	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('row')}>
					<div className={styles('row-left')}>
						{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
					</div>
					<div className={styles('row-right')}>
						<CopyrightLinks links={links} />
					</div>
				</div>
			</Theme.Container>
		</div>
	)
}

const CopyrightLinks: React.FC<{
	links: Array<LinkType>
}> = ({links}) => {
	if (!links || links.length === 0) return null

	return (
		<div className={styles.links()}>
			{links.map(
				(link, i) =>
					link && (
						<Fragment key={i}>
							{i > 0 && <span className={styles.links('divider')}>|</span>}
							<div className={styles.links('item')}>
								<Link to={link.url} className={styles.links('item-link')}>
									{link.description || link.title}
								</Link>
							</div>
						</Fragment>
					)
			)}
		</div>
	)
}
